import { useEffect, useState } from "react";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import { deleteApi, getApi, postApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

export default function BackupList() {
  const [backupData, setBackupData] = useState([]);
  const [creating, setCreating] = useState(false);
  const [creatingFiles, setCreatingFiles] = useState(false);

  const getBackup = async (params) => {
    const path = "admin/backups";
    try {
      const response = await getApi({ path, params: { ...params } });
      setBackupData(response?.data?.files);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBackup({});
  }, []);

  async function createBackup() {
    setCreating(true);
    try {
      await postApi({ path: "admin/backups" });
      successMessage("بک اپ دیتابیس با موفقیت گرفته شد");
      getBackup({});
    } catch (error) {
      errorMessage(
        error?.response?.data?.errors?.[0]?.message ||
          "خطا در گرفتن بک اپ دیتابیس"
      );
    } finally {
      setCreating(false);
    }
  }
  async function createFilesBackup() {
    setCreatingFiles(true);
    try {
      await postApi({ path: "admin/backups/files" });
      successMessage("بک اپ فایل‌ها و تصاویر با موفقیت گرفته شد");
      getBackup({});
    } catch (error) {
      errorMessage(
        error?.response?.data?.errors?.[0]?.message ||
          "خطا در گرفتن بک اپ فایل‌ها"
      );
    } finally {
      setCreatingFiles(false);
    }
  }
  async function downloadFile(filename) {
    const validName = filename.split(".")[0];
    const response = await getApi({
      path: `admin/backups/${validName}`,
      responseType: "blob",
    });

    const blob = response.data;
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url); // آزادسازی URL
  }
  async function removeFile(filename) {
    try {
      await deleteApi({
        path: `admin/backups/${filename}`,
      });
      getBackup({});
      successMessage("فایل با موفقیت حذف شد");
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex justify-between items-center gap-4 flex-wrap">
        <Title title={"لیست بک اپ"} />
        <div className="flex gap-2 flex-wrap">
          <Button
            onClick={createBackup}
            text={creating ? "در حال گرفتن بک اپ..." : "بک اپ دیتابیس"}
            color="success"
            type="button"
            disabled={creating || creatingFiles}
            className="whitespace-nowrap min-w-fit"
          />
          <Button
            onClick={createFilesBackup}
            text={
              creatingFiles ? "در حال گرفتن بک اپ..." : "بک اپ فایل‌ها و تصاویر"
            }
            color="primary"
            type="button"
            disabled={creating || creatingFiles}
            className="whitespace-nowrap min-w-fit"
          />
        </div>
      </div>

      <ul className="divide-y divide-gray-200 dark:divide-gray-700 mt-8">
        {backupData?.map((item, index) => {
          return (
            <li key={index} className="py-3">
              <div className="flex items-center space-x-4 rtl:space-x-reverse">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                    {item.name}
                  </p>
                </div>
                <button
                  onClick={() => downloadFile(item?.name)}
                  type="button"
                  className="focus:outline-none text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm px-4 py-1.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900"
                >
                  دانلود
                </button>
                <button
                  onClick={() => removeFile(item?.name)}
                  type="button"
                  className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-md text-sm px-4 py-1.5 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                >
                  حذف
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
